import { gql } from '@apollo/client';

export const ACFMediaFragment = gql`
  fragment ACFMedia on MediaItemConnectionEdge {
    node {
      title
      mediaItemUrl
      srcSet
      sizes
      altText
      mediaDetails {
        height
        width
      }
    }
  }
`;
